import { UppyFile, FileMeta, FileBody } from './index'

async function postRequest(url: string, json: string) {
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: json
  })
  if (!res.ok) {
    // throw new Error("postRequest failed to: " + url);
    // TODO: let the caller do the error handling
    const el = document.getElementById("uploader-errors") as HTMLElement;
    el.innerHTML = "Request failed: " + url;
  }
  return res;
}

// Unused now
export async function gssFetchS3Keys(files: UppyFile<FileMeta, FileBody>[]) {
  // Request GSS API to generate S3-keys for the files to upload
  console.log("gssFetchS3Keys", files);
  const data = { files: files.map(file => [file.name, file.id]) }
  const res = await postRequest("/api/v1/eu/generate_s3_keys", JSON.stringify(data))
  return await res.json();
}

function generateSecureRandom(length: number = 16): string { // for length = 16, returned string is length 32
  const array = new Uint8Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
}

function sanitizeFilename(filename: string): string {
  return encodeURIComponent(filename);
}

export function generateS3Key(file: UppyFile<FileMeta, FileBody>) {
  console.log('generateS3Keys', file);
  const random = generateSecureRandom();
  const prefix = "uploads-uppy-" + random;
  const sanitizedName = sanitizeFilename(file.name);
  return `${prefix}-${sanitizedName}`;
}

export async function gssGetUploadParams(args: {
  albumId: number;
  filename: string;
  contentType: string;
}): Promise<{
  method: 'PUT';
  url: string;
  headers: Record<string, string>;
  fields: Record<string, string>;
  s3_key: string;
}> {
  const res = await postRequest(
    '/api/v1/eu/upload_params',
    JSON.stringify({
      album_id:     args.albumId,
      filename:     args.filename,
      content_type: args.contentType,
    })
  );
  if (!res.ok) throw new Error('Failed to fetch upload parameters');
  return res.json();
}

export async function gssCreatePhoto(file: UppyFile<FileMeta, FileBody>, albumId: number) {

  console.log("gssCreatePhoto", file);

  const photo = {
    file_name: file.name,
    file_size: file.size,
    file_type: file.type,
    s3_key: file.meta.s3Key,
    album_id: albumId,
  }

  const res = await postRequest("/api/v1/eu/photos/create", JSON.stringify(photo))
  return await res.json()
}

